import { IDataTableColumn, Loading, FGCustomPanel } from "nsitools-react";
import * as React from "react";
import { useParams } from "react-router";

import { BreedApi, BreedGridDto, BreedSearch, KennelApi, KennelSaveBreedsDto } from "../../../../../api";
import { ERoutes } from "../../../../../ERoutes";
import { SRSHCustomSelector, SmallFormGenerator } from "../../../../../components";
import { useGlobalData } from "../../../../../contexts";
import { useApiService, useTl, useCrudApi } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { Link } from "react-router-dom";

export interface IKennelBreedPageProps {}

export const KennelBreedPage: React.FunctionComponent<IKennelBreedPageProps> = (props) => {
  const { id, state } = useParams<{ id: string; state: string }>();
  const { t } = useTl();
  const kennelApi = useApiService(KennelApi);
  const breedApi = useApiService(BreedApi);
  const { currentLanguage } = useGlobalData();

  const { data, loading, saveItem, saving } = useCrudApi<KennelSaveBreedsDto>(
    {
      getApiFn: () => kennelApi.getAllowedBreedsIds(+id),
      saveApiFn: (d) => kennelApi.saveLinkedBreeds(d),
      onSavedRoute: (d) => `${ERoutes.kennel}/${+id}/breeds/edit`,
    },
    [id]
  );

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.BreedGroupLabel),
        fieldName: "breedGroupLabel",
        render: (row: BreedGridDto) => (
          <Link target="_blank" to={`${ERoutes.breedGroups}/${row.breedGroupId}/detail/view`}>
            {row.breedGroupLabel}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
        render: (row: BreedGridDto) => (
          <Link target="_blank" to={`${ERoutes.breeds}/${row.breedId}/detail/view`}>
            {row.name}
          </Link>
        ),
      },
    ],
    [t]
  );

  const searchBreedIdsFunction = React.useCallback(
    (sObj) => breedApi.getIds(BreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [breedApi, currentLanguage.languageId]
  );
  const searchBreedFunction = React.useCallback(
    async (sObj) => {
      const res = await breedApi.baseSearch(BreedSearch.fromJS({ ...sObj, languageId: currentLanguage.languageId }));
      console.log("all ids, ", res);
      return res;
    },
    [breedApi, currentLanguage.languageId]
  );

  return (
    <Loading isLoading={loading}>
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={state === "edit"}
        loading={loading}
        saving={saving}
      >
        <FGCustomPanel>
          {(ctx) => (
            <SRSHCustomSelector
              linkedIds={ctx.formik.values.breedIds}
              columns={columns}
              onLinkedIdsChanged={(ids) => ctx.formik.setFieldValue("breedIds", ids)}
              idField="breedId"
              searchFunction={searchBreedFunction}
              searchIdsFunc={searchBreedIdsFunction}
              editMode={state === "edit"}
            />
          )}
        </FGCustomPanel>
      </SmallFormGenerator>
    </Loading>
  );
};
